module.exports = __webpack_public_path__ + "static/logo-saam-11a766287a8993a5cf5df4aefe6b136f.png";